module.exports = __webpack_public_path__ + "static/media/GraduationCapHover.4d6c7b5b.svg";